





























import Vue, { PropType } from "vue";
import "@/components/icons";
import { Data, Methods, Computed, Props } from "./types";
import { sendGaEvent } from "@/helpers/ga-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "Selectbox",
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array as PropType<Props["options"]>,
      required: true
    },
    valueType: {
      type: String,
      default: "string",
      validator(value) {
        return ["", "string", "number"].includes(value);
      }
    },
    size: {
      type: String,
      default: "medium",
      validator: function(value) {
        return ["exSmall", "small", "medium", "large"].includes(value);
      }
    },
    iconName: {
      type: String,
      default: ""
    },
    postfixLabel: {
      type: String,
      default: ""
    },
    boxWidth: {
      type: Number,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  computed: {
    typeClass() {
      return {
        "select--type--string": this.valueType === "string",
        "select--type--number": this.valueType === "number"
      };
    },
    sizeClass() {
      return {
        "selectContent--size--small": this.size === "small"
      };
    }
  },
  mounted() {
    // this.$emit("change", this.options[0].value);
  },
  methods: {
    selectedItemLabel(value: string) {
      const selectedItem = this.options.find(option => option.value == value);
      if (!selectedItem) return "";
      return selectedItem.label;
    },
    updateValue(event) {
      sendGaEvent(this, {
        gaEventLabel: {
          value: event.target.value,
          label: this.selectedItemLabel(event.target.value)
        }
      });
      this.$emit("input", event.target.value);
    }
  }
});
